module.exports = __webpack_public_path__ + "img/holder.b50550d5.svg";